<template>
  <section class="hero">
    <div class="container">
      <h1 class="title">{{ $t("research.hero.title") }}</h1>
      <header class="header-group">
        <div class="">
          <p class="subtitle">
            <span>{{ $t("research.hero.subtitle1") }}&nbsp;</span>
            <span>{{ $t("research.hero.subtitle2") }}</span>
          </p>
          <p class="subtitle">
            {{ $t("research.hero.subtitle3") }}
          </p>
          <p class="text">
            {{ $t("research.hero.text") }}
          </p>
        </div>
      </header>
    </div>
  </section>
</template>

<script>
import { PATHS } from "@/data/nav";

export default {
  name: "researchHero",
  data() {
    return {
      PATHS,
    };
  },
};
</script>

<style scoped>
.hero {
  padding-top: clamp(3rem, 1.6163rem + 5.1485vw, 6.25rem);
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: clamp(1rem, -0.2772rem + 4.7525vw, 4rem);
  position: relative;
}

.header-group {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.row {
  display: flex;
  flex-direction: row;
  /* gap: 1rem; */
  justify-content: space-between;
}
@media screen and (max-width: 768px) {
  .row {
    flex-wrap: wrap;
  }
}

.hero .title {
  font-size: clamp(2rem, -1.1399rem + 11.6832vw, 9.375rem);
  font-weight: 400;
  line-height: 1;
  text-transform: uppercase;
  text-align: left;
}

.subtitle {
  font-size: clamp(1.5rem, 0.4889rem + 3.7624vw, 3.875rem);
  color: var(--color-primary);
  line-height: 1.6;
  text-transform: uppercase;
  font-weight: 400;
  text-align: left;
  font-family: "Krona One", sans-serif;
  width: 100%;
  margin: 0 0 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: clamp(1rem, -0.2772rem + 4.7525vw, 4rem);
}

.text {
  font-weight: 500;
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  line-height: 1.5;
  text-align: left;
  margin-bottom: 0;
}

@media screen and (min-width: 768px) {
  .text {
    max-width: 380px;
    position: absolute;
    bottom: 0;
    left: 1rem;
  }

  .subtitle + .subtitle {
    text-align: right;
    display: block;
  }
}
</style>
